import React from 'react'
import { Field } from '@/components/PickupModal.styles'
import { Textfield } from '@big-red-group/storefront-common-ui'
import { TrackBookingFieldEnteredInput } from '@/types'

type CustomPickupProps = {
  onChange: (pickup: string) => void
  location?: string
  bookingFieldEntered?: (bookingField: TrackBookingFieldEnteredInput) => void
}

const CustomPickup: React.FC<CustomPickupProps> = ({ onChange, location, bookingFieldEntered }) => {
  const handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value)
    bookingFieldEntered?.({
      label: 'BookingPickupCustom',
      value: e.currentTarget.value,
      section: 'Pick up location',
      fieldTitle: `Please enter your hotel name in the field below`,
      fieldType: 'select',
    })
  }

  return (
    <Field>
      <label>Please enter your hotel name in the field below</label>
      <Textfield placeholder="e.g. Hilton Surfers Paradise" onChange={handleOnChange} value={location} />
    </Field>
  )
}

export default CustomPickup
